import React, { useState } from "react";
import { Form, Input, Tooltip } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import toast from "react-hot-toast";
import { useNavigate } from 'react-router-dom';
import { ResetApi } from "../../api/request/users";
import { removeCookies } from "../../services/Cookies.jsx";
import { useSelector } from 'react-redux';
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import Lock from "../../assets/auth/Lock.jsx";
import { handleApiError } from "../../utils/handleApiError.js";
import { useResponsive } from "../../hooks/useResponsive.js";
import { InfoCircleOutlined } from "@ant-design/icons";
import Tagline from "./Tagline.jsx";

function ResetPassword() {

  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  const { broker } = useSelector(state => state.broker);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ newpassword: "", confirmpassword: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { newpassword, confirmpassword } = formData;
    if (newpassword !== confirmpassword) {
      toast.error("New password and Confirm password do not match");
      return;
    }

    if (!newpassword || !confirmpassword) {
      toast.error("New password or Confirm password can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        password: (formData?.newpassword),
        confirmPassword: (formData?.confirmpassword),
        domain: 'upforex.live'
      }

      const { data } = await ResetApi(params);
      if (data?.success) {
        toast.success(data?.message);
        localStorage.clear('email');
        removeCookies('passwordToken');
        navigate("/");
      }
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsLoading(false);
    }
  };

  const PasswordRequirements = () => (
    <div className="text-base text-gray-500">
      <p className="text-[#2F2B3D] font-semibold mb-3">Password Requirements:</p>
      <ul className="list-disc pl-5 space-y-3 text-sm">
        <li>Minimum 8 characters long - the more, the better</li>
        <li>At least one lowercase character and uppercase character</li>
        <li>At least one number and one special character</li>
      </ul>
    </div>
  );

  return (
    <>
      {!isMobile ? (
        <div className='flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg'>
          <Tagline />
          <div className='w-full max-w-md bg-white p-10 rounded-2xl shadow-xl'>
            <div className="flex justify-center mb-6">
              <img src='/assets/logo/logo.png' alt='logo' className='h-20 w-48 object-contain ' />
            </div>
            <div className="text-center">
              <p className="text-[#2F2B3D] text-2xl font-semibold auth-heading">
                Reset Your Password
              </p>
              <p className="text-[silver] text-sm font-medium auth-com mt-2 ">
                Please enter your new password to continue.
              </p>
            </div>

            <div className="w-full">
              <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="w-full text-sm font-normal py-1 mt-3">
                  <div div className="relative">
                    <img
                      src="../assets/images/lock.svg"
                      alt=""
                      className="absolute top-[15%] left-5"
                    />
                    <Form.Item name="newpassword">
                      <Input.Password
                        placeholder="Enter your new password"
                        className="border rounded-lg w-full ps-4 py-2 transperant-input"
                        prefix={
                          <Lock />
                        }
                        name="newpassword"
                        onChange={handleChange}
                        value={formData.newpassword}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="w-full text-sm font-normal py-1 mt-3">
                  <div div className="relative">
                    <img
                      src="../assets/images/lock.svg"
                      alt=""
                      className="absolute top-[15%] left-5"
                    />
                    <Form.Item name="confirmpassword">
                      <Input.Password
                        placeholder="Confirm your password"
                        className="border rounded-lg w-full ps-4 py-2 transperant-input"
                        prefix={
                          <Lock />
                        }
                        name="confirmpassword"
                        onChange={handleChange}
                        value={formData.confirmpassword}
                      />
                    </Form.Item>
                  </div>
                </div>

                <div className="mt-5">
                  <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Reset Password' isLoading={isLoading} loadingLable='Reseting Password...' />
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="min-h-screen bg-blue-50 mobile-dashboard">
          <div className="p-5 pt-10">
            <div className="flex justify-center mb-8">
              <img
                src="/assets/logo/logo.png"
                alt="logo"
                className="h-16 w-44 object-contain"
              />
            </div>

            <div className="w-full">
              <div className="my-5 mt-10">
                <p className="text-xl font-bold mb-2 text-dark-200">
                  Reset Password
                </p>
                <p className="text-gray-500">
                  Please enter your new password to continue.
                </p>
              </div>

              <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="w-full text-sm font-normal py-1 mt-3">
                  <div className="flex items-center gap-2 mb-2">
                    <label className="text-sm font-medium text-gray-700">New Password</label>
                    <Tooltip
                      title={<PasswordRequirements />}
                      placement="bottom"
                      styles={{ root: { maxWidth: '350px' } }}
                      color="white"
                    >
                      <InfoCircleOutlined className="text-gray-500 hover:text-primary" />
                    </Tooltip>
                  </div>
                  <div div className="relative">
                    <img
                      src="../assets/images/lock.svg"
                      alt=""
                      className="absolute top-[15%] left-5"
                    />
                    <Form.Item name="newpassword">
                      <Input.Password
                        placeholder="New password"
                        className="border rounded-lg w-full ps-4 py-2 transperant-input"
                        prefix={<Lock />}
                        name="newpassword"
                        onChange={handleChange}
                        value={formData.newpassword}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="w-full text-sm font-normal py-1 mt-3">
                  <div className="flex items-center gap-2 mb-2">
                    <label className="text-sm font-medium text-gray-700">Confirm Password</label>
                  </div>
                  <div div className="relative">
                    <img
                      src="../assets/images/lock.svg"
                      alt=""
                      className="absolute top-[15%] left-5"
                    />
                    <Form.Item name="confirmpassword">
                      <Input.Password
                        placeholder="Confirm password"
                        className="border rounded-lg w-full ps-4 py-2 transperant-input"
                        prefix={<Lock />}
                        name="confirmpassword"
                        onChange={handleChange}
                        value={formData.confirmpassword}
                      />
                    </Form.Item>
                  </div>
                </div>

                <div className="mt-5">
                  <LoadableButton
                    type="submit"
                    className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-[14px] w-full py-3 text"
                    lable="Reset Password"
                    isLoading={isLoading}
                    loadingLable="Reseting Password..."
                  />
                </div>

                <div className="primary flex items-center justify-center mt-5 text-sm">
                  <a href="/" className="underline">
                    Back to login
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default ResetPassword;
